import React, {useEffect,useState} from 'react';
import { toast } from "react-toastify";
import axios from '../../axios';

const DeletePointCategories = (props) => {

const [pointcategories, addpointcategories] = useState({});

useEffect(()=>{

    axios.get('point-categories/id?id=' + props.match.params.id)
         .then(    (data) => {
            addpointcategories(data.data)
        })
         .catch(err =>  console.log(err))
},[])

const handleSubmit = (e) => {
    e.preventDefault();
    axios.delete('point-categories/?id='+ pointcategories.id )
        .then(
            (data) => {
                toast.success("Category has been deleted successfully!");
               window.history.back();
            }
        )
        .catch(err => console.log(err));
}
    console.log(pointcategories)
    return(
        <div className='editcities p-5 text-left'>
            <div className='row'><h1>Delete Category</h1></div>
            <div className='row'>By clicking delete button you agree to delete category with name {pointcategories.name}</div>
            <form onSubmit={handleSubmit}>
          
                <input type='text'  placeholder='pointcategories Name'  value={pointcategories.name} disabled></input>
                
                <input type='text' placeholder='Phone Prefix'  value={pointcategories.active ? 'Active': 'Passive'} disabled></input>
            
                <button type='submit'>Delete</button>
            </form>
        </div>

    )
}
export default DeletePointCategories;
